// @flow
import * as React from 'react';

import { useRouter } from './useRouter';

export function withRouter(Component: React.ComponentType<*>) {
  const displayName = `withRouter(${Component.displayName || Component.name})`;

  function WrapperComponent(props: *) {
    // eslint-disable-next-line clubmed/use-router-with-generic
    const { history, location } = useRouter();
    return <Component {...props} history={history} location={location} />;
  }

  WrapperComponent.displayName = displayName;

  return WrapperComponent;
}
